import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {CarsPermissionPipesModule} from 'app/permissions/pipes/cars-permission-pipes.module';
import {ReferenceSummaryExpandedTableModule} from '../reference-summary-expanded-table/reference-summary-expanded-table.module';
import {ReferenceSummaryTableComponent} from './reference-summary-table.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatSlideToggleModule,
    ReferenceSummaryExpandedTableModule,
    CarsPermissionPipesModule,
  ],
  declarations: [ReferenceSummaryTableComponent],
  exports: [ReferenceSummaryTableComponent],
})
export class ReferenceSummaryTableModule {}
